import React from "react";
import FullWidthHalfHeight from "./configurations/FullWidthHalfHeight";
import FullWidthThirdHeight from "./configurations/FullWidthThirdHeight";
import HalfWidthHalfHeight from "./configurations/HalfWidthHalfHeight";
import HalfWidthThirdHeight from "./configurations/HalfWidthThirdHeight";
import { Ring } from "@uiball/loaders";
import { HeightRestriction, WidthRestriction } from "../../../../../interfaces/Restrictions";
import EmptyContainer from "../../../../containers/EmptyContainer";
import NoDataAvailable from "@appsinti/ui-core/NoDataAvailable";
import StatsDay from "../../../../../interfaces/StatsDay";
import { useDateProvider } from "@appsinti/date-provider";

const DaySection: React.FC<{
  day: StatsDay | null;
  loading: boolean;
  heightRestriction: HeightRestriction;
  widthRestriction: WidthRestriction;
}> = ({ day, loading, heightRestriction, widthRestriction }) => {
  if (loading) {
    return (
      <EmptyContainer>
        <Ring color={"white"} size={30} />
      </EmptyContainer>
    );
  }

  if (!day) {
    return (
      <NoDataAvailable />
    );
  }

  const { isFutureDate } = useDateProvider();

  switch (widthRestriction) {
    case "full-width":
      if (heightRestriction === "half")
        return <FullWidthHalfHeight day={day} isFutureDate={isFutureDate} />;
      if (heightRestriction === "third")
        return <FullWidthThirdHeight day={day} isFutureDate={isFutureDate} />;
      return null;
    case "half-width":
      if (heightRestriction === "half")
        return <HalfWidthHalfHeight day={day} isFutureDate={isFutureDate} />;
      if (heightRestriction === "third")
        return <HalfWidthThirdHeight day={day} isFutureDate={isFutureDate} />;
      return null;
    default:
      return null;
  }
};

export default DaySection;
